import Column from 'antd/lib/table/Column';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/illustration-car-on-the-bridge.svg';

const dataSourceKeys = ['10', '9', '7', '6', '5'];

const columnsData = [
    {
        key: 'step',
        width: 450,
        dataIndex: 'step',
    },
    {
        key: 'level',
        width: 450,
        dataIndex: 'level',
    },
];

interface DataSource {
    key: number;
    step: string;
    level: string;
}

export const ExposureExample1Step = withTranslation('cbt')(({ t }: WithTranslation) => {
    const columnsTranslations: Column<{}>[] = t('week-7.exposure-example-1.examplesTable.columns', {
        returnObjects: true,
    });

    const dataSourceTranslations: DataSource[] = t(
        'week-7.exposure-example-1.examplesTable.dataSource',
        {
            returnObjects: true,
        },
    );

    const columns = columnsData.map((columnData, index: number) => ({
        title: columnsTranslations[index],
        ...columnData,
    }));

    const dataSource = dataSourceTranslations.map((dataSourceTranslation, index: number) => ({
        ...dataSourceTranslation,
        key: dataSourceKeys[index],
        level: dataSourceKeys[index],
    }));

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn md={12}>
                    <S.StepHeading>{t('week-7.exposure-example-1.title')}</S.StepHeading>
                    <S.StepDescription small>
                        {t('week-7.exposure-example-1.description')}
                    </S.StepDescription>
                </S.ContentColumn>
                <S.ContentColumn md={12}>
                    <S.StepIcon style={{ height: '10rem' }} iconUrl={stepIcon} />
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow>
                <S.StyledTable columns={columns} dataSource={dataSource} pagination={false} />
            </S.ContentRow>
        </>
    );
});
